module.exports = __webpack_public_path__ + "img/隨緣自強2 的副本.3def248c.jpg";